import { useMemo } from 'react';
import { useMergeSemantic, useSemanticRootStyle } from '../../_util/hooks/useMergeSemantic';
import { useComponentConfig } from '../../config-provider/context';
export const useTypographySemantic = (customizePrefixCls, classNames, styles, typographyDirection, props) => {
    const { getPrefixCls, direction: contextDirection, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, } = useComponentConfig('typography');
    const direction = typographyDirection ?? contextDirection;
    const rootPrefixCls = getPrefixCls();
    const prefixCls = getPrefixCls('typography', customizePrefixCls);
    const mergedProps = {
        ...props,
        prefixCls,
        direction,
    };
    const contextClassNamesObject = useMemo(() => ({ root: contextClassName }), [contextClassName]);
    const contextStyleRoot = useSemanticRootStyle(contextStyle);
    const [mergedClassNames, mergedStyles] = useMergeSemantic([contextClassNamesObject, contextClassNames, classNames], [contextStyles, contextStyleRoot, styles], {
        props: mergedProps,
    });
    return [mergedClassNames, mergedStyles, prefixCls, direction, rootPrefixCls];
};
